import * as types from "./constants";

const initialState = {
  queue: [],
  timelinePhases: [],
  progress: { completed: 0, total: 0, percentage: 0 },
  queueLoading: false,
  dismissing: false,
  restoring: false,
  currentTemplateId: null,
  templateGovernanceItems: [],
  templateGovernanceLoading: false,
};

// Apply a queue response payload (queue + timeline_phases + progress) to state.
// The pathway is deterministic — dismiss/restore return the SAME shape as fetch,
// so they update the view directly (no refetch/polling, nothing to wait on).
const applyQueuePayload = (state, payload) => ({
  ...state,
  queue: payload?.queue || [],
  timelinePhases: payload?.timeline_phases || [],
  progress: payload?.progress || initialState.progress,
});

const OnboardingBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ONBOARDING_QUEUE:
      return {
        ...state,
        queueLoading: action.payload?.silent ? state.queueLoading : true,
      };
    case types.FETCH_ONBOARDING_QUEUE_SUCCESS:
      return { ...applyQueuePayload(state, action.payload), queueLoading: false };
    case types.FETCH_ONBOARDING_QUEUE_FAILURE:
      return { ...state, queueLoading: false };

    case types.DISMISS_QUEUE_ITEM:
      return { ...state, dismissing: true };
    case types.DISMISS_QUEUE_ITEM_SUCCESS:
      // The dismiss endpoint returns the fresh queue → update in place. Guard
      // against the legacy minimal {dismissed:true} shape so we never wipe state.
      return Array.isArray(action.payload?.queue)
        ? { ...applyQueuePayload(state, action.payload), dismissing: false }
        : { ...state, dismissing: false };
    case types.DISMISS_QUEUE_ITEM_FAILURE:
      return { ...state, dismissing: false };

    case types.RESTORE_QUEUE_ITEM:
      return { ...state, restoring: true };
    case types.RESTORE_QUEUE_ITEM_SUCCESS:
      return Array.isArray(action.payload?.queue)
        ? { ...applyQueuePayload(state, action.payload), restoring: false }
        : { ...state, restoring: false };
    case types.RESTORE_QUEUE_ITEM_FAILURE:
      return { ...state, restoring: false };

    case types.FETCH_TEMPLATE_GOVERNANCE:
      return { ...state, templateGovernanceLoading: true };
    case types.FETCH_TEMPLATE_GOVERNANCE_SUCCESS:
      return {
        ...state,
        templateGovernanceLoading: false,
        templateGovernanceItems: action.payload || [],
      };
    case types.FETCH_TEMPLATE_GOVERNANCE_FAILURE:
      return {
        ...state,
        templateGovernanceLoading: false,
        templateGovernanceItems: [],
      };

    case types.SET_CURRENT_TEMPLATE:
      return {
        ...state,
        currentTemplateId: action.payload,
        templateGovernanceItems: [],
      };

    case types.RESET_BUILDER:
      return { ...initialState };

    default:
      return state;
  }
};

export default OnboardingBuilderReducer;
